import React from 'react';
import { Table, Icon, Button, Modal, Popconfirm, message, Upload, Tooltip, Tabs, Select } from 'antd';
import { translate } from 'react-i18next';
import { compose } from 'redux';
import ModalClass from '../../components/ModalClass'
import ConfirmSubject from '../../components/ConfirmSubject'
import ImportSummary from '../../components/ImportSummary'
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import Papa from "papaparse/papaparse.min.js"
import moment from 'moment';
import * as R from 'ramda'
const { TabPane } = Tabs;
const { Option } = Select

class SchoolAdminClass extends React.Component {

  constructor() {
    super();
    this.state = {
      modalOpen: false,
      modalData: null,
      modalMode: null,
      toRemove: "",
      sorting: null,
      confirmSubject: false,
      confirmData: null,
      //For add students to multiple classes
      selectedRowKeys: [],
      studentsToAdd: [],
      overviewData: false
    }
  }

  saveModal = (data, mode, classId) => {

    const  school_id = this.props.profile.profile.school.id;
    const { subject_categories, subjects } = this.props
    let students = {}
    data.students.map( student => {
      students[student] = true
    })

    //Find category of subject
    const subject_category = subjects[data.subject].category
    const subject_category_name = subject_categories[subject_category].name


    let grade;
    if (data.grade !== 'None' && data.gradeNumber) {
      grade = data.grade+" "+data.gradeNumber
    } else {
      grade = 'None'
    }

    let teacher;
    if (typeof data.teacher === 'string') {
      teacher == data.teacher
    } else {
      teacher = {}
      data.teacher.map( user => {
        teacher[user] = true
      })
    }

    if (mode == 'edit') {
      this.props.firebase.database().ref(`/schools/${school_id}/classes/${classId}`).update({
        name: data.className,
        grade: grade,
        subject: data.subject,
        students: students,
        teacher: data.teacher,
        subject_category: subject_category_name
      })
    } else {
      const key = this.props.firebase.database().ref(`/schools/${school_id}/classes/`).push().key
      this.props.firebase.database().ref(`/schools/${school_id}/classes/${key}`).set({
        name: data.className,
        grade: grade,
        subject: data.subject,
        students: students,
        teacher: data.teacher,
        subject_category: subject_category_name,
        createdAt: moment().valueOf()
      })

    }
    this.setState({modalOpen: false})
  }

  openModal = (mode, data) => {
    this.setState({modalOpen: true, modalData: data, modalMode: mode})
  }

archiveClass = (unarchive) => {
  const  school_id = this.props.profile.profile.school.id;
  const classId = this.state.toRemove
  this.props.firebase.database().ref(`/schools/${school_id}/classes/${classId}`).update({
    archived: unarchive ? false : true
  })
}

  deleteClass = (classId) => {
    const school_id = this.props.profile.profile.school.id
    this.props.firebase.database().ref(`/schools/${school_id}/classes/${classId}`).remove()
  }

handleSorting = (pagination, filters, sorter) => {
  this.setState({ sorting: sorter });
}

importData = (file) => {
  const _this = this
   Papa.parse(file.file, {
     delimiter: ",",
     header: true,
     download: false,
     skipEmptyLines: true,
     complete: function(results) {
       _this.saveCSV(results.data);
     }
   });
}

saveCSV = (data) => {

  const schoolId = this.props.profile.profile.school.id;
  const schoolName = this.props.profile.profile.school.name
  const allSubjects = this.props.subjects && Object.entries(this.props.subjects)
  let overviewData = {
    newClasses: [],
    updatedClasses: []
  }

  let missingStudents = []
  let toConfirm = []

  data.map( clss => {
    //Find subject by name
    let subjects = allSubjects.filter( subject =>
      subject[1].name == clss.Subject
      &&
      subject[1].category
    )
    //Find teacher
    let teacherIds = clss['Teacher ID'].split(';')
    let teachers = []
    let teacherNames = []

    teacherIds.map( teach => {
        let teacher = this.props.teachers && this.props.teachers.filter( teacher =>
          teacher[1].profile.id == teach
        )
        teacher = teacher.map( tch => {
          teachers.push(tch[0])
          teacherNames.push(`${tch[1].profile.name} ${tch[1].profile.last_name}`)
        })
    })
    //Find students
    let studentList = clss['Student List'].split(';')
    let students = {}
    let studentNames = []
    studentList.map( user => {
      if (user !== '') {
        let student = this.props.students && this.props.students.filter( stud =>
          stud[1].profile.id
          &&
          (stud[1].profile.id.toString().replace(/\s/g, '') == user
          ||
          stud[1].profile.id.toString().replace(/\s/g, '') == user.toString())
        )
        if (student.length == 0) {
          missingStudents.push(user)
        } else{
          students[student[0][0]] = true
          studentNames.push(`${student[0][1].profile.name} ${student[0][1].profile.last_name}`)
        }
      }
    })
    //Grade
    let grade;
    if (clss.Grade) {
      grade = clss.Grade
    } else {
      grade = 'None'
    }

    if (subjects.length == 0) { //New subjects to be added
        let confirmSubject = [
          `${clss.Subject} (${clss.Classname})`,
          {
            name: clss.Classname,
            grade: clss.Grade || 'None',
            students: students,
            teacher: teachers,
            subject_category: clss['Subject Group'],
            subject_name: clss.Subject,
            teacherNames,
            studentNames,
            createdAt: moment().valueOf()
          }]
          toConfirm.push(confirmSubject)
    } else {
        const subject_categories = this.props.subject_categories
        const categoryId = subjects[0][1].category
        const subjectCategory = subject_categories[categoryId].name

        //Teacher error checking
        if (Object.keys(teachers).length == 0) {
          console.log(`Error importing ${clss.Classname}: no teacher were found with ID ${clss['Teacher ID']}`);
          message.error(`Error importing ${clss.Classname}: no teacher were found with ID ${clss['Teacher ID']}`, 10)
        }
        //Student error checking
        if (missingStudents.length !== 0) {
          console.log(`Students with the following IDs are not found: ${missingStudents.toString()} `);
          message.error(`Students with the following IDs are not found: ${missingStudents.toString()} `, 10)
        }

        let clssObj = {
          name: clss.Classname,
          grade: clss.Grade || 'None',
          subject: subjects[0][0],
          students: students,
          teacher: teachers,
          subject_category: subjectCategory,
          subject_name: subjects[0][1].name,
          createdAt: moment().valueOf()
        }

        let existingClass = this.isNewClass(clssObj)
        if (!existingClass) {
          overviewData.newClasses.push({
            ...clssObj,
            createdAt: moment().valueOf(),
            teacherNames,
            studentNames 
          })
          this.props.firebase.database().ref(`/schools/${schoolId}/classes`).push(clssObj)
        } else {
          overviewData.updatedClasses.push({
            ...clssObj,
            teacherNames,
            studentNames,
            prevStudents: existingClass.students ? this.getStudentsById(Object.keys(existingClass.students)) : []
          })
          this.props.firebase.database().ref(`/schools/${schoolId}/classes/${existingClass.id}`).update(clssObj)
        }
    }
  })
  if (toConfirm.length > 0 ) {
    this.setState({
      confirmSubject: true,
      confirmData: toConfirm,
      overviewData
    })
  } else {
    this.setState({overviewData})
  }

}

getStudentsById = (ids) => {
  console.log('ids', ids)
  let studentNames = []
  ids.map( studentId => {
    if (studentId !== '') {
      let student = this.props.students && this.props.students.filter( stud =>
        stud[0] === studentId
      )
      if (student.length != 0) {
        studentNames.push(`${student[0][1].profile.name} ${student[0][1].profile.last_name}`)
      } 
    }
  })
  return studentNames;
}

onClassConfirm = () => {
  const classes = this.state.confirmData
  const schoolId = this.props.profile.profile.school.id;
  const categories = this.props.subject_categories
  let overviewData = this.state.overviewData || {
    newClasses: [],
    updatedClasses: []
  }

  let newSubjects = []
  classes.map( item => {
    let clss = item[1]
    let categoryId = []
     for (let key in categories) {
       if (categories[key].name == clss.subject_category.trim()) {
         categoryId = key
       }
     }
    if (categoryId.length > 0) {
      //Check if already added to avoid duplicates
      const addedClass = newSubjects.filter( subj => subj.name == clss.subject_name)
      if (addedClass.length == 0) {
        const subjectId = this.props.firebase.database().ref('/subjects').push().key
        this.props.firebase.database().ref(`/subjects/${subjectId}`).set({
          name: clss.subject_name,
          category: categoryId,
          readOnly: false
        })
        clss.subject = subjectId
        newSubjects.push({name: clss.subject_name, id: subjectId})
      } else {
        clss.subject = addedClass[0].id
      }

      let existingClass = this.isNewClass(clss)
      console.log(overviewData, this.state.overviewData)
      if (!existingClass) {
        overviewData.newClasses.push(clss)
        delete clss.teacherNames
        delete clss.studentNames
        this.props.firebase.database().ref(`/schools/${schoolId}/classes`).push(clss)
      } else {
        overviewData.updatedClasses.push({
          ...clss,
          prevStudents: existingClass.students ? this.getStudentsById(Object.keys(existingClass.students)) : []
        })
        delete clss.teacherNames
        delete clss.studentNames
        this.props.firebase.database().ref(`/schools/${schoolId}/classes/${existingClass.id}`).update(clss)
      }

      this.setState({confirmSubject: false, confirmData: null, overviewData})
    } else {
      console.log(`Couldn't import class ${clss.Classname}; subject group ${clss.subject_category} doesn't exist.`);
      message.error(`Couldn't import class ${clss.Classname}; subject group ${clss.subject_category} doesn't exist.`)
    }
  })
}

isNewClass = (clss) => {
  console.log('clss', clss)
  let { classes } = this.props.school
  if (!classes) {
    return true
  } else {
    let matchedClass = Object.entries(classes).filter( item =>
      item[1]
      && 
      item[1].name === clss.name
      &&
      item[1].teacher
      &&
     (item[1].teacher[0] === clss.teacher[0] || item[1].teacher === clss.teacher[0])
      &&
      item[1].grade === clss.grade
      &&
      item[1].subject === clss.subject
      &&
      !item[1].archived
    )
    if (matchedClass.length > 0) {
      return {
        ...matchedClass[0][1], 
        id: matchedClass[0][0]
      }
    } else {
      return false
    }
  }
}

translateGrade = grade => {
  const { t } = this.props
  if (grade) {
    grade = grade.split(' ');
    grade[0] = t(grade[0]);
    if (grade[0] === 'Niveau scolaire') {
      grade[0] = 'Niv. S.';
    }
    return grade.join(' ');
  } else {
    return '';
  }
};

  selectStudents = () => {
    const { students, t } = this.props
    const _this = this
    let studentsToAdd = []
    Modal.confirm({
      title: t('Choose students to add to selected classes'),
      content: (
          <Select optionFilterProp='children' style={{ width: '100%' }} mode="multiple" onChange={(value) => studentsToAdd = value}>
            {students && students.map(student => (
              <Option value={student[0]}>{student[1].profile.name + ' ' + student[1].profile.last_name}</Option>
            ))}
          </Select>
        ),
      onOk() {
        if (studentsToAdd.length > 0) {
          _this.addStudents(studentsToAdd)
        }
      },
    })
  }

  addStudents = (studentsToAdd) => {
    const { selectedRowKeys } = this.state
    const { school: {classes}, firebase } = this.props
    const  school_id = this.props.profile.profile.school.id;

    selectedRowKeys.map( classId => {
      let students = classes[classId].students || {}
      studentsToAdd.map( studentId => {
        students[studentId] = true
      })
      firebase.database().ref(`/schools/${school_id}/classes/${classId}/students`).set(students)
    })
  }

  render() {
    const { t } = this.props;
    let tableData = [];
    let tableData_archived = []
    
    if (this.props.school && this.props.school.classes && this.props.students && this.props.teachers && this.props.subjects) {
      let classes = Object.entries(this.props.school.classes)
      classes.map( (item, i) => {
        let students = item[1].students && Object.keys(item[1].students)
        let studentList = []
        students && students.map( student => {
          if (student !== null && student[1]) {
            const name = this.props.students.filter( element =>
              element[0] == student
            )
            if (name.length > 0 ) {
              studentList.push(name[0][1].profile.name+' '+name[0][1].profile.last_name)
            }
          }
        })
        studentList = studentList.join(', ')

        let teacher;
        if (typeof item[1].teacher === 'string') {
          teacher = this.props.teachers.filter( teacher =>
            teacher[0] == item[1].teacher
          )
          teacher = teacher.length !== 0 && teacher[0][1].profile.name+' '+teacher[0][1].profile.last_name
        } else if (item[1].teacher && item[1].teacher.length > 0) {

          teacher = this.props.teachers
            .filter( teacher => item[1].teacher.includes(teacher[0]))
            .map( teacher => teacher[1].profile.name+' '+teacher[1].profile.last_name)
            .join(', ')
        }

        let subject = Object.entries(this.props.subjects)
        subject = subject.filter( subject =>
          subject[0] == item[1].subject
        )
        if (subject.length>0) {
          subject = t(subject[0][1].name)
        }

        let row = {
            key: item[0],
            className: item[1].name,
            classId: item[0],
            grade: this.translateGrade(item[1].grade),
            studentlist: studentList,
            student_ids: students,
            teacher: teacher || null,
            teacher_id: item[1].teacher || null,
            subject: subject,
            subject_id: item[1].subject,
            subjectgroup: t(item[1].subject_category),
            edit: item[1].archived ? '' : <Icon style={{fontSize: '24px'}} type="edit" />,
            delete: item[1].archived ? (     
                <Popconfirm placement="top" title={t('Are you sure you want to delete this class?')} onConfirm={(e) => this.deleteClass(item[0])} okText={t("Yes")} cancelText={t("No")}>
                  <Tooltip placement="left" title="Delete class">
                    <Icon style={{ fontSize: '24px', color: '#ff4d4f' }} type="delete" />
                  </Tooltip>
                </Popconfirm>
            ) : '',
            archive: item[1].archived
              ? <Popconfirm placement="top" title={t('Are you sure you want to unarchive this class?')} onConfirm={(e) => this.archiveClass('unarchive')} okText={t("Yes")} cancelText={t("No")}>
                  <Button type="danger">{t('Unarchive')}</Button>
                </Popconfirm>
              : <Popconfirm placement="top" title={t('Are you sure you want to archive this class?')} onConfirm={(e) => this.archiveClass()} okText={t("Yes")} cancelText={t("No")}>
                  <Button type="danger">{t('Archive')}</Button>
                </Popconfirm>
          }

          if (item[1].archived) {
            tableData_archived.push(row)
          } else {
            tableData.push(row)
          }

        })
    }

    let sortTable = this.state.sorting || {};

    const columns = [
            {
              title: t('Class name'),
              dataIndex: 'className',
              key: 'className',
              sorter: true,
              width: 250,
              sorter: (a, b) => a.className.localeCompare(b.className),
              sortOrder: sortTable.columnKey === 'className' && sortTable.order,
            },
            {
              title: t('Grade'),
              dataIndex: 'grade',
              key: 'grade',
              sorter: true,
              width: '150px',
              sorter: (a, b) => a.grade.localeCompare(b.grade),
              sortOrder: sortTable.columnKey === 'grade' && sortTable.order,
            },
            {
              title: t('Teacher'),
              dataIndex: 'teacher',
              key: 'teacher',
              sorter: true,
              width: 150,
              sorter: (a, b) => a.teacher && a.teacher.localeCompare(b.teacher),
              sortOrder: sortTable.columnKey === 'teacher' && sortTable.order,
            },
            {
              title: t('Subject'),
              dataIndex: 'subject',
              key: 'subject',
              sorter: true,
              width: 150,
              sorter: (a, b) => typeof a.subject === 'string' && a.subject.localeCompare(b.subject),
              sortOrder: sortTable.columnKey === 'subject' && sortTable.order,
            },
            {
              title: t('Subject group'),
              dataIndex: 'subjectgroup',
              key: 'subjectgroup',
              sorter: true,
              sorter: (a, b) => a.studentlist.localeCompare(b.studentlist),
              sortOrder: sortTable.columnKey === 'subjectgroup' && sortTable.order,
            },
            {
              title: t('Student List'),
              dataIndex: 'studentlist',
              key: 'studentlist',
              sorter: true,
              sorter: (a, b) => a.studentlist.localeCompare(b.studentlist),
              sortOrder: sortTable.columnKey === 'studentlist' && sortTable.order,
            },
            {
              title: '',
              dataIndex: 'edit',
              key: 'edit',
              onCell: (record) => {
                return {
                  onClick: () => {this.openModal('edit', record)}
                  };
                }
            },
            {
              title: '',
              dataIndex: 'delete',
              key: 'edit',
            },
            {
              title: '',
              dataIndex: 'archive',
              key: 'archive',
              onCell: (record) => {
                return {
                  onClick: () => {this.setState({toRemove: record.classId})}
                  };
                }
            },

    ]

    const rowSelection = {
      selectedRowKeys: this.state.selectedRowKeys,
      onChange: (selectedRowKeys, selectedRows) => this.setState({selectedRowKeys}),
    };

    return (
      <div>
        <div style={styles.container} className='schoolAdmin'>
        <div style={styles.submenu}>
        <Upload accept=".csv" customRequest={this.importData} showUploadList={false} style={{float: 'right'}}>
          <Button style={styles.buttonBlue} type="primary">
            <Icon type="upload" /> {t('Import CSV')}
          </Button>
        </Upload>
        <Button
          onClick={() => this.openModal('add')}
          style={styles.buttonBlue} type="primary"
        >
          <Icon type="user-add"/>{t('Add Class')}
        </Button>
        {this.state.selectedRowKeys.length > 0 &&
          <Button
            onClick={() => this.selectStudents()}
            style={{...styles.buttonBlue, marginRight: 20}} type="primary"
          >
            <Icon type="usergroup-add"/>{t('Add Students')}
          </Button>
        }
        </div>
        <div style={styles.inner}>
          <h3 style={{fontSize: 22, fontWeight: 'bold'}}>{t('Classes')}</h3>
          <Tabs defaultActiveKey="1">
            <TabPane tab={t('Active')} key="1">
              <Table
                rowSelection={rowSelection}
                onChange={this.handleSorting}
                id='log-table'
                columns={columns}
                dataSource={tableData}
                rowSelection={rowSelection}
              />
            </TabPane>
            <TabPane tab={t('Archived')} key="">
              <Table
                onChange={this.handleSorting}
                id='log-table'
                columns={columns}
                dataSource={tableData_archived}
              />
            </TabPane>
          </Tabs>
        </div>
        </div>
        <ModalClass
          mode={this.state.modalMode}
          data={this.state.modalData}
          open={this.state.modalOpen}
          subjects={this.props.subjects}
          subject_categories={this.props.subject_categories}
          students={this.props.students}
          teachers={this.props.teachers}
          cancel={() => this.setState({modalOpen: false})}
          save={this.saveModal}
          subject_categories={this.props.subject_categories}
          t={this.props.t}
        />
        <ConfirmSubject
          open={this.state.confirmSubject}
          data={this.state.confirmData}
          cancel={() => this.setState({confirmSubject: false, toConfirm: []})}
          save={this.onClassConfirm}
        />
        <ImportSummary 
          visible={this.state.overviewData !== false && !this.state.confirmSubject} 
          importSummary={this.state.overviewData} 
          close={() => this.setState({overviewData: false})}
        />
      </div>
    )
  }
}

const enhancer = compose(
  translate('lang'),
  firebaseConnect((props, store) => {
    const state = store.getState()
    const schoolId = R.path(['firebase','profile','profile','school','id'], state)
    const paths = ['auth', 'subjects', 'profile', 'subject_categories']
    if (schoolId) {
      paths.push(`/schools/${schoolId}`);
    }
    return paths;
  }),
  connect(
    state => {
      const schoolId = state.firebase.profile.profile.school.id

      return {
        profile: state.firebase.profile,
        students: state.studentsOfSchool.students,
        subjects: state.firebase.data.subjects,
        subject_categories: state.firebase.data.subject_categories,
        teachers: state.teachersOfSchool.teachers,
        school: state.firebase.data.schools && state.firebase.data.schools[schoolId]
      }
    }
  )
)
export default enhancer(SchoolAdminClass);

const styles = {

  container: {
    padding: '20px',
  },

  buttonBlue: {
    float: 'right',
    fontSize: '17px',
    backgroundColor: '#4A90E2',
    border: 'none',
    fontSize: '14px',
    borderRadius: '15px',
  },

  submenu: {
    marginBottom: '20px',
    overflow: 'hidden'
  },

  inner: {
    padding: 20,
    backgroundColor: 'white',
    boxShadow: '0 1px 3px 1px rgba(119,151,178,0.16)',
    marginBottom: '80px'
  }
}



// WEBPACK FOOTER //
// ./src/containers/SchoolAdminClass/index.jsx